import { Button, Card, Typography } from "antd";
import Link from "next/link";
import "./FaqIsHelpfulSection.css";
import Image from "next/image";
import { useState } from "react";
import { useIntl } from "react-intl";

const FaqIsHelpfulSection = () => {
  const intl = useIntl();

  const [selected, setSelected] = useState<"up" | "down" | "">("");

  const handleClick = (value: "up" | "down") => {
    if (selected === value) {
      setSelected("");
      return;
    }
    setSelected(value);
  };

  return (
    <div className="faq-is-helpful-section mt-20">
      <div className="d-flex gap-16 align-items-center">
        <Typography className="fw-500 fs-15">
          {intl.formatMessage({ id: "faqIsHelpful?" })}
        </Typography>
        <div className="faq-is-helpful-buttons">
          <Button
            type="link"
            className="thumbs-up-button"
            aria-label={intl.formatMessage({ id: "yesText" })}
            onClick={() => handleClick("up")}
            icon={
              <Image
                src={
                  selected === "up" ? "/assets/need_help/thumb_up_filled.svg" : "/assets/need_help/thumb_up.svg"
                }
                alt="Thumbs Up"
                width={16}
                height={16}
              />
            }
          >
            {intl.formatMessage({ id: "yesText" })}
          </Button>
          <Button
            type="link"
            className="thumbs-down-button"
            aria-label={intl.formatMessage({ id: "noText" })}
            onClick={() => handleClick("down")}
            icon={
              <Image
                src={
                  selected === "down" ? "/assets/need_help/thumb_up_filled.svg" : "/assets/need_help/thumb_up.svg"
                }
                alt="Thumbs Down"
                width={16}
                height={16}
                className="thumbs-down-icon"
              />
            }
          >
            {intl.formatMessage({ id: "noText" })}
          </Button>
        </div>
      </div>

      {selected === "down" && (
        <Card className="faq-is-helpful-card">
          <Typography className="lh-normal">
            {intl.formatMessage(
              { id: "faqHelpfulSuggestion" },
              {
                contactUsLink: (
                  <Link href="/contact">
                    {intl.formatMessage({ id: "contactUs" })}
                  </Link>
                ),
              }
            )}
          </Typography>
        </Card>
      )}
    </div>
  );
};

export default FaqIsHelpfulSection;
